import { ChangeDetectionStrategy, Component } from "@angular/core";

import { SvgComponent } from "../svg/svg.component";

@Component({
  selector: "mn-splash-screen",
  templateUrl: "./splash-screen.component.html",
  styleUrls: ["./splash-screen.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent],
})
export class SplashScreenComponent {}
